import { useState } from 'react'
import Layout from '@/component/Layout/Layout'
import usePollDetailTab from './usePollDetailTab'
import { PageHeader } from '@/ui-components/components/PageHeader'
import TicketDetails, {
  type TicketViewMode,
} from '@/ui-components/components/TicketDetails'
import TabBar from '@/ui-components/components/TabBar'
import type { TabItem } from '@/ui-components/components/TabBar/TabBar.types'
import { BiReceipt, BiTable } from 'react-icons/bi'

const VIEW_TABS: TabItem[] = [
  { label: 'ticketDetails.ticketView', value: 'ticket', icon: <BiReceipt /> },
  { label: 'ticketDetails.tableView', value: 'table', icon: <BiTable /> },
]

type PollDetailTabProps = { isHistory?: boolean }
const PollDetailTab = ({ isHistory }: PollDetailTabProps) => {
  const {
    title,
    onBack,
    ticket,
    loading,
    betDetails,
    onClickCheckResult,
    canCancel,
    onCancel,
    dialogComponent,
  } = usePollDetailTab(isHistory)
  const [viewMode, setViewMode] = useState<TicketViewMode>('ticket')

  return (
    <Layout loading={loading}>
      {dialogComponent}
      <div className="w-full max-w-5xl mx-auto sm:px-6">
        <PageHeader title={title} onBack={onBack} />
        <div className="w-full flex flex-col gap-4 sm:gap-6">
          <div className="w-full flex justify-end">
            <TabBar
              tabs={VIEW_TABS}
              activeTab={viewMode}
              onChange={(value) => setViewMode(value as TicketViewMode)}
              variant="default"
              size="md"
            />
          </div>
          <TicketDetails
            ticketNumber={ticket.ticketNumber}
            betDate={ticket.betDate}
            listTitle={ticket.listTitle}
            drawDate={ticket.drawDate}
            amount={ticket.amount}
            winAmount={ticket.winAmount}
            status={ticket.status}
            canCancel={canCancel}
            onCancel={onCancel}
            onClickCheckResult={onClickCheckResult}
            betDetails={betDetails}
            viewMode={viewMode}
          />
        </div>
      </div>
    </Layout>
  )
}

export default PollDetailTab
